/* Admin-only route config. Consumed by app-router-admin.tsx (the admin chunk lazy-loaded from app-router.tsx on /admin/* routes). No public/user code. */
/* eslint-disable react-refresh/only-export-components -- route config module, not a component file */
import type { IRouteProps } from '@/app/router-types'

import { AccountCreateView } from './account/account-create'
import { AccountDetailsView } from './account/account-details'
import { AccountListView } from './account/account-list'
import { UserCreateView } from './user/user-create'

export const adminRoutes: IRouteProps[] = [
  {
    id: 'ACCOUNT_LIST',
    name: 'ACCOUNT_LIST',
    path: 'accounts',
    view: <AccountListView />,
    documentTitle: 'ACCOUNTS',
    options: {},
  },
  {
    id: 'ACCOUNT_DETAILS',
    name: 'ACCOUNT_DETAILS',
    path: 'account/details/:id',
    view: <AccountDetailsView />,
    documentTitle: 'ACCOUNT_DETAILS',
    options: {},
  },
  {
    id: 'ACCOUNT_CREATE',
    name: 'ACCOUNT_CREATE',
    path: 'account/create',
    view: <AccountCreateView />,
    documentTitle: 'CREATE_ACCOUNT',
    options: {},
  },
  {
    id: 'USER_CREATE',
    name: 'USER_CREATE',
    path: 'user/create',
    view: <UserCreateView />,
    documentTitle: 'CREATE_USER',
    options: {},
  },
]

export const RouterConfiguration = (): IRouteProps[] => adminRoutes
